import request from "@assets/js/axios";
const { instance: $axios } = request;
class Hotel {
  constructor() {}
  ad() {
    return $axios.get("/api/v2/hotelAd");
  }
}

export default new Hotel();
